import { Box, Dialog, Typography, Button, Grid, MenuItem, TextField } from "@mui/material";
import "./popup.css";
import { GoogleMap, useJsApiLoader, Marker,  LoadScript} from "@react-google-maps/api";
import React, { useState, useCallback, useEffect,useRef } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import GooglePlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';

// ,
const containerStyle = {
  width: "100%",
  height: "400px",
};

const libraries = ["places"];



function GoogleMapPop(props) {
  const { open, handleClose,isLoaded,setMap,marker,centerPoint, setCenterPoint ,handleClick,handleAddMaps} = props;
  const [value, setValue] = useState(null);
  const [autocompletes, setAutocomplete] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [searchCoordinates, setSearchCoordinates] = useState(null);
  const inputRef = useRef(null);
  
  const onLoad = useCallback(function callback(map) {
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

  const handleLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  function handleClearField() {
    setValue(null);
    setSearchCoordinates(null);
  }

  function handlePlaceChanged() {
    if (autocompletes !== null) {
      const place = autocompletes?.getPlace();
      if (place && place.formatted_address) {
        setInputValue(place.formatted_address);
        const location = place?.geometry?.location;
        if (location) {
          const lat = location?.lat();
          const lng = location?.lng();
          setSearchCoordinates({ lat, lng });
        } else {
          alert("Try again");
        }
      }
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  }

  const handleSelect = async (value) => {
    setValue(value);
    const results = await geocodeByAddress(value.label);
    const latLng = await getLatLng(results[0]);
    setSearchCoordinates(latLng);
    setCenterPoint(latLng);
  };

  useEffect(() => {
    if (autocompletes && inputRef.current) {
      
      autocompletes.addListener("place_changed", handlePlaceChanged);
    }

    return () => {
      if (autocompletes && inputRef.current) {
        window?.google.maps.event.clearInstanceListeners(autocompletes);
      }
    };
  }, [autocompletes]);

  useEffect(() => {
    let my_res = JSON.parse(sessionStorage.getItem("property_info"));

    if (my_res?.property_cordinates?.coordinates) {
      setCenterPoint({lat: my_res?.property_cordinates?.coordinates[0],lng:my_res?.property_cordinates?.coordinates[1]})
    } else {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(function (position) {
          
          const new_center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setCenterPoint(new_center);
        });
      } else {
        alert("Geolocation is not available in your browser.");
      }
    }
  }, []);

  
  return (
    <>
     
      <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="google-map"
      >
        {/* <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_KEY} libraries={libraries}> */}
        <Box>
          <Box className="d-flex-between popup-header">
            <Typography fontSize={"20px"}>Select your location</Typography>
            <IoIosCloseCircleOutline
              className={"contact-close"}
              onClick={handleClose}
            />
          </Box>
          <Box p={3}>
            <Box
              display={"flex"}
              alignItems={"center"}
              gap={"10px"}
              justifyContent={"space-between"}
              mb={2}
            >
              <Box className="d-flex" gap={"15px"} >
              <Box  width={"400px"}>
              <GooglePlacesAutocomplete
            selectProps={{
              value,
              onChange: handleSelect,
              placeholder: 'Search for a place...',
            }}
          />
              </Box>
              {/* <GoogleAutocomplete
          onLoad={handleLoad}
          // onPlaceChanged={handlePlaceChanged}
        >
              <TextField
                    inputRef={inputRef}
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder="Search for your location"
                    className="loc-search-field"
                  />
                   </GoogleAutocomplete> */}
                  {value &&
                    <Button
                size="small"
                className={"retake-btn"}
                  onClick={handleClearField}
              >
                clear
              </Button>}
              </Box>
              <Button
                size="small"
                className={"capture-btn"}
                  onClick={handleAddMaps}
              >
                Add
              </Button>
            </Box>
            {isLoaded ? (
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={centerPoint}
                zoom={10}
                onLoad={onLoad}
                onUnmount={onUnmount}
                onClick={handleClick}
              >
                {marker && (
                  <Marker position={{ lat: marker.lat, lng: marker.lng }} draggable={true} onDragEnd={handleClick} />
                )}
              </GoogleMap>
            ) : (
              <Typography>Not found</Typography>
            )}
          </Box>
        </Box>
        {/* </LoadScript> */}
      </Dialog>
      {/* </LoadScript> */}
    </>
  );
}



export default GoogleMapPop;
